import React, { useEffect } from "react";
import { Select, SelectProps } from "antd";
import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import { ZUid } from "src/types/zUid";
import { loadServicesForObject } from "src/businessServices/apiBusinessServices";
import { ObjectServiceExt } from "src/businessServices/businessServises.types";
import { onError } from "src/common/onError";

const objectServicesSelectorStore = makeAutoObservable({
  services: [] as ObjectServiceExt[],
  loading: false,

  async loadServices(objectId: ZUid) {
    this.setLoading(true);
    try {
      const servicesData = await loadServicesForObject(objectId, {
        translate: true,
      });
      this.setServices(servicesData);
    } catch (error) {
      onError(error);
    } finally {
      this.setLoading(false);
    }
  },

  reset() {
    this.setServices([]);
    this.setLoading(false);
  },

  setServices(services: ObjectServiceExt[]) {
    this.services = services;
  },

  setLoading(loading: boolean) {
    this.loading = loading;
  },

  get options() {
    return this.services.map((service: ObjectServiceExt) => ({
      label: service.name,
      value: service.id,
      filterProp: `${service.name} ${service.serviceKey}`,
    }));
  },
});

interface ObjectServicesSelectorProps
  extends Omit<SelectProps, "loading" | "options"> {
  objectId?: ZUid;
}

export const ObjectServicesSelector: React.FC<ObjectServicesSelectorProps> =
  observer(({ objectId, ...selectProps }) => {
    useEffect(() => {
      if (objectId) {
        objectServicesSelectorStore.loadServices(objectId);
      }
      return () => objectServicesSelectorStore.reset();
    }, [objectId]);

    return (
      <Select
        {...selectProps}
        options={objectServicesSelectorStore.options}
        loading={objectServicesSelectorStore.loading}
        showSearch
        placeholder="Выбрать"
        allowClear
        disabled={selectProps.disabled}
      />
    );
  });
